export default "__VITE_ASSET__CMVi04Gm__"